import { DataRow } from './DataTable';

export {
  Features,
  EffectiveDefinition,
  BooleanColumnSchema,
  DateTimeColumnSchema,
  isDateTimeColumnSchema,
  isNumericColumnSchema,
  NumericColumnSchema,
  Schema,
  StringColumnSchema,
} from './EffectiveDefinition';
export { DataTable, DataRow, Value } from './DataTable';
export {
  ValueAccessor,
  throwIfUndefined,
  undefinedToNull,
  undefinedToZero,
  extractDatumFromVictoryRow,
} from './Accessor';
export { DateTrunc, DateGranularity, dateGranularityFromTrunc, dateTruncFromGranularity } from './DateGranularity';
export { HistoricalComparisonSpec, makeHistoricalComparisonSpec } from './comparisonSpec/HistoricalComparisonSpec';
export { MarkBasedComparisonSpec, makeMarkBasedComparisonSpec } from './comparisonSpec/MarkBasedComparisonSpec';
export { NoComparisonSpec, makeNoComparisonSpec } from './comparisonSpec/NoComparisonSpec';
export { StaticComparisonSpec, makeStaticComparisonSpec } from './comparisonSpec/StaticComparisonSpec';
export {
  ComparisonSpecType,
  isStaticComparison,
  isMarkBasedComparison,
  isNoComparison,
  isHistoricalComparisonSpec,
  isHistoricalOrMarkBasedComparison,
  shouldShowComparisonLine,
} from './comparisonSpec/ComparisonSpecType';

// This is a numeric enum because of some specific unique circumstances (the
// roles function as indices into an array of values in some code, sorta like a
// dictionary but a bit different), and it was created before the tslint rule.
// Probably we should convert to a string enum.
// tslint:disable-next-line:prefer-string-enums
export enum MetricValueRole {
  CURRENT,
  ABSOLUTE_CHANGE,
  PERCENTAGE_CHANGE,
}

export interface TimestampedItem {
  readonly timestamp: Date;
}

export interface MeasuredItem<T> {
  readonly measure: T;
}

export interface DataPoint extends TimestampedItem, MeasuredItem<number> {}

export interface NullableDataPoint extends TimestampedItem, Partial<MeasuredItem<number>> {}

export type DataPoints = ReadonlyArray<DataPoint>;

export interface DataPointWithComparison extends NullableDataPoint {
  readonly comparison?: DataPointWithComparison;
}

export const getDataRowFromDataPoint = (dataPoint: DataPointWithComparison): DataRow => {
  return {
    measure: dataPoint.measure,
    timestamp: dataPoint.timestamp,
    comparisonMeasure: dataPoint.comparison?.measure,
    comparisonTimestamp: dataPoint.comparison?.timestamp,
  };
};

export type DataPointsWithComparison = ReadonlyArray<DataPointWithComparison>;

export interface ComparisonDelta {
  /** difference between the compared values */
  readonly absolute: number;
  /** percentage difference between the compared values */
  readonly percentage: number;
  readonly comparedPoint: DataRow;
}

export interface MetricPillValue {
  readonly role: MetricValueRole;
  readonly value: number;
}

export const detailTypes: ReadonlyArray<MetricValueRole> = [
  MetricValueRole.ABSOLUTE_CHANGE,
  MetricValueRole.PERCENTAGE_CHANGE,
];

export const listTypes: ReadonlyArray<MetricValueRole> = [
  MetricValueRole.CURRENT,
  MetricValueRole.ABSOLUTE_CHANGE,
  MetricValueRole.PERCENTAGE_CHANGE,
];

// Fully Inclusive dateRange
// [first, last]
export interface DateRange {
  readonly first: Date;
  readonly last: Date;
}

export enum FiscalYearStartMonth {
  JANUARY = 1,
  FEBRUARY = 2,
  MARCH = 3,
  APRIL = 4,
  MAY = 5,
  JUNE = 6,
  JULY = 7,
  AUGUST = 8,
  SEPTEMBER = 9,
  OCTOBER = 10,
  NOVEMBER = 11,
  DECEMBER = 12,
}
